// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__ldCOE","loading-spinner":"loading-spinner__S1YeY","ctaButton":"ctaButton__QoOd6","loginButton":"loginButton__UATV9","passwordForgotten":"passwordForgotten__BbHBG","textInput":"textInput__YTKt9","textInputLogin":"textInputLogin__yWSgE","bigbeat":"bigbeat__wz8Up"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"spinner\":\"spinner__ldCOE\",\"loading-spinner\":\"loading-spinner__S1YeY\",\"ctaButton\":\"ctaButton__QoOd6\",\"loginButton\":\"loginButton__UATV9\",\"passwordForgotten\":\"passwordForgotten__BbHBG\",\"textInput\":\"textInput__YTKt9\",\"textInputLogin\":\"textInputLogin__yWSgE\",\"bigbeat\":\"bigbeat__wz8Up\"}";
        // 1787130557192
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  